export default "__VITE_ASSET__DjqNweef__"